import { Box, Container, Typography } from "@mui/material";

import ProgressPointsTable from "./ProgressPoints.table";

const ProgressPointsReference = () => {
  return (
    <Container maxWidth="xl">
      <Box mt={3}>
        <Typography variant="h2">Training Center</Typography>
      </Box>
      <Box mt={3}>
        <Typography variant="h3" sx={{ mb: 1 }}>
          Progress Points
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Progress Points are used in the NIAP portal to track estimated and
          actual dates on which certain defined milestones within the
          Pre-Evaluation and Evaluation Phases are achieved. Estimated dates are
          pre-defined and expected to be kept up to date by the point Owner in
          order to reflect the current delivery schedule.
        </Typography>
        <ProgressPointsTable />
      </Box>
    </Container>
  );
};

export default ProgressPointsReference;
